<template>
  <button
      @click="download"
      type="button"
      class="btn btn-primary view-store-btn"
      :class="loadingStatus"
  >
    <div class="inline w-5 h-5" v-if="loadingStatus=='loading'">
      <svg width="24" height="24" viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round" xmlns="http://www.w3.org/2000/svg"><path d="M10.72,19.9a8,8,0,0,1-6.5-9.79A7.77,7.77,0,0,1,10.4,4.16a8,8,0,0,1,9.49,6.52A1.54,1.54,0,0,0,21.38,12h.13a1.37,1.37,0,0,0,1.38-1.54,11,11,0,1,0-12.7,12.39A1.54,1.54,0,0,0,12,21.34h0A1.47,1.47,0,0,0,10.72,19.9Z"><animateTransform attributeName="transform" type="rotate" dur="0.75s" values="0 12 12;360 12 12" repeatCount="indefinite"/></path></svg>
    </div>
    <FeatherWrapper v-else icon="download" />&nbsp;
    <span><slot /></span>
  </button>
</template>

<script setup>
import { defineEmits, defineProps } from "vue";
import { getPdf } from "@/services/ancestry";
import store from "@/store/index";
import { useLoading } from "@/composables/useLoading";

const props = defineProps({
  type: String,
});

const emit = defineEmits(["error", "clearError"]);

const { loadingStatus, finishLoading, failLoading, resetLoading } = useLoading("loaded");

function download() {
  resetLoading();
  emit("clearError");
  getPdf(store.getters.profile.profile.barcode, props.type)
      .then(finishLoading)
      .catch(() => {
          failLoading("Sorry, we could not download your file ");
          emit("error");
      });
}
</script>
